import { useState } from "react";
import Answered from "./Answered";


import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, increment, ref, update } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoIJhPzLa5mEDuLkk7UDOgOYIcYXmrGCs",
  authDomain: "bdh-news-quiz.firebaseapp.com",
  databaseURL: "https://bdh-news-quiz-default-rtdb.firebaseio.com",
  projectId: "bdh-news-quiz",
  storageBucket: "bdh-news-quiz.firebasestorage.app",
  messagingSenderId: "346870888705",
  appId: "1:346870888705:web:4a68e945ff2529c7d18300",
  measurementId: "G-GYT1KP4L4M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getDatabase(app); // Pass the app instance to getDatabase()

function MCQuestion(props) {
  const [answered, setAnswered] = useState(false);
  const [correct, setCorrect] = useState();
  const [selected, setSelected] = useState("none");

  const {
    question,
    number,
    choices,
    answer,
    image,
    alt,
    explanation,
    link,
    setNumAnswered,
    setNumCorrect,
    imgPath,
    answer_i,
  } = props;

  const handleClick = (e) => {
    setAnswered(true);
    setNumAnswered((c) => c + 1);
    setSelected(parseInt(e.target.name));
    if (e.target.value === "true") {
      updateQuizScore(number, true);
      setCorrect(true);
      setNumCorrect((c) => c + 1);
    } else {
      updateQuizScore(number, false);
      setCorrect(false);
    }
  };

  const changeButton = (i) => {
    if (!answered) {
      return "Choice AllButton";
    } else if (correct && i === answer_i) {
      return "Correct AllButton";
    } else if (!correct && i === answer_i) {
      return "IncorrectCorrect AllButton";
    } else if (!correct && i === selected) {
      return "Incorrect AllButton";
    } else {
      return "Other AllButton";
    }
  };

  function updateQuizScore(questionId, isCorrect) {
    const quizId = window.location.hash.replace("#/", "");

    const [month, day, year] = quizId.split("-").map(Number);
    const quizDate = new Date(2000 + year, month - 1, day); 
    const cutoff = new Date(2025, 9, 24); // 2025-10-24

    if (quizDate < cutoff) {
      console.log("Old quiz — not sending data to database.");
      return;
    }

    const path = `${quizId}/q${questionId}/${isCorrect ? 'correct' : 'incorrect'}`;

    const updates = {};
    updates[path] = increment(1);

    update(ref(db), updates)
      .then(() => {
        console.log(`Score for ${questionId} updated successfully.`);
      })
      .catch((error) => {
        console.error("Error updating score: ", error);
      });
  }


  return (
    <div>
      <div className="Question">
        <h4 className="num">{number}.</h4>
        {image != null && image.length > 0 && (
          <img src={imgPath + image} alt={alt} />
        )}
        <h4>{question}</h4>
        <div className="Options">
          {choices.map((choice, i) => (
            <div className="ButtonGroup" key={`Q${number}.${i}`}>
              <button
                className={changeButton(i)}
                onClick={handleClick}
                value={i === answer_i}
                name={i}
                disabled={answered}
              >
                {choice}
                {i === answer_i && selected !== "none" ? (
                  <img
                    src={process.env.PUBLIC_URL + "/images/happy-bear.png"}
                    alt={"happy bear for correct answer"}
                    className="ChoiceBear"
                  />
                ) : (
                  i === selected &&
                  !correct && (
                    <img
                      src={process.env.PUBLIC_URL + "/images/sad-bear.png"}
                      alt={"sad bear for wrong answer"}
                      className="ChoiceBear"
                    />
                  )
                )}
              </button>
            </div>
          ))}
          {answered && (
            <Answered correct={correct} explanation={explanation} link={link} />
          )}
          {/* <div className="MoreInfo">
              {correct ? (
                <p>
                  <b>Correct!</b> {explanation}
                </p>
              ) : (
                <p>
                  <b>Incorrect!</b> {explanation}
                </p>
              )}
              {link && (
                <a href={link} target="_blank" rel="noreferrer noopener">
                  Read more! &rarr;
                </a>
              )}
            </div> */}
        </div>
      </div>
      <hr />
    </div>
  );
}

export default MCQuestion;
